import i18n from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translations from '../../translations.json';
import panelTerminologyPostProcessor from './terminologyPostProcessor';

i18n
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .use(panelTerminologyPostProcessor)
  .init({
    resources: translations,
    lng: window.localStorage.getItem('I18N_LANGUAGE') || 'en',
    fallbackLng: 'en',
    supportedLngs: (import.meta.env.VITE_APP_USE_LANGUAGES || 'en').split(','),
    debug: false,
    lowerCaseLng: 'true',
    defaultNS: 'COMMON',
    fallbackNS: 'COMMON',
    load: 'currentOnly',
    postProcess: ['panelTerminology'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'I18N_LANGUAGE',
      caches: ['localStorage'],
    },
  });

export default i18n;
